import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ServiceRequestService} from '../../../../../Services/service-request.service';
import {environment} from '../../../../../../../environments/environment';
import {InvoiceCustom} from '../../../../../../back-office/Models/InvoiceCustom';
import {InvoiceService} from '../../../../../Services/invoice.service';

@Component({
  selector: 'app-dealer-reply-step-invoice',
  templateUrl: './dealer-reply-step-invoice.component.html',
  styleUrls: ['./dealer-reply-step-invoice.component.scss']
})
export class DealerReplyStepInvoiceComponent implements OnInit {
  @Input() Index;
  @Input() isActive;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  public baseUrl = environment.apiUrl;
  public customInvoice: InvoiceCustom = new InvoiceCustom();
  public replyItem;

  constructor(
    private requestService: ServiceRequestService,
    private invoiceService: InvoiceService
  ) { }

  ngOnInit() {
    this.requestService.serviceRequest.subscribe(serviceRequest => {
      const replyItems = serviceRequest.reply.replyItems.filter(item => !item.solutionStep.restricted);
      if (replyItems[this.Index]) {
        this.replyItem = replyItems[this.Index];
        if (this.replyItem.replyCreditInvoice && this.replyItem.replyCreditInvoice.creditInvoice) {
          this.customInvoice = this.replyItem.replyCreditInvoice.creditInvoice;
        }
      }
    });
  }

  openPdfFile() {
    this.invoiceService.getPdf(this.customInvoice.id).subscribe(res => {
      if (res && typeof res === 'object') {
        const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
        el.setAttribute('href', res.url);
        el.setAttribute('download', res.filename);
        el.click();
      }
    });
  }
}
